import { render } from "./bigNumber.vue?vue&type=template&id=2ba35564"
import script from "./bigNumber.vue?vue&type=script&lang=js"
export * from "./bigNumber.vue?vue&type=script&lang=js"

import "./bigNumber.vue?vue&type=style&index=0&id=2ba35564&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__